import React from 'react'

import { Form, Col } from '_zari/core'

import * as AuthService from 'services/auth.service'

const CompaniaFormGroup = ({ companiaSeleccionada, setCompaniaSeleccionada }) => {
  const [companias, setCompanias] = React.useState([])

  React.useEffect(() => {
    AuthService.getCompaniasHabilitadas().then(({ data }) => {
      setCompanias(data)
    })
  }, [])

  return (
    <Form.Group>
      <Form.Label text='COMPAÑIA A COMPARAR' htmlFor='select-compania' md={4} alignRightAt='md' />
      <Col md={8}>
        <Form.Select
          id='select-compania'
          name='select-compania'
          value={companiaSeleccionada}
          onChange={e => setCompaniaSeleccionada(e.target.value)}
        >
          <option value=''>Seleccionar</option>
          {companias.map(x => (
            <option key={x._id} value={x._id}>
              {x.razonSocial}
            </option>
          ))}
        </Form.Select>
      </Col>
    </Form.Group>
  )
}

export default React.memo(CompaniaFormGroup)
